import script from "./PUR08_002INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR08_002INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR08_002INS.vue?vue&type=style&index=0&id=352f9e34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352f9e34"]])

export default __exports__